import './ObjectiveTypeIcon.css';

import React from 'react';
import FieldIcon from '../../../b2b-common/FieldIcon';
import { ReactComponent as RegularObjectiveTypeIcon } from '../../../../resources/icons/objectives/threshold-off-quant.svg';
import { ReactComponent as ThresholdObjectiveTypeIcon } from '../../../../resources/icons/objectives/threshold-on-quant.svg';
import { ReactComponent as RangeObjectiveTypeIcon } from '../../../../resources/icons/objectives/within-threshold-on-quant.svg';
import { getIconWithTooltip } from '../helper';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const ObjectiveTypeIcon = ({ objective, showFieldName = true }) => {
    const { t } = useB2BTranslation('b2b-plans');

    const returnIcon = () => {
        if ((objective.objectiveType === 'QUANTITATIVE') || (objective.objectiveType === 'QUANTITATIVE_DIMENSIONAL')) {
            const expectedObjectiveTrend = (objective.startQuantitativeValue <
                objective.endQuantitativeValue) ? 'Increase' : 'Decrease';
            const toolTip = expectedObjectiveTrend === 'Increase' ?
                t('Quantitative Objective - Increase') :
                t('Quantitative Objective - Decrease');
            return getIconWithTooltip(RegularObjectiveTypeIcon, {}, toolTip);
        }
        if ((objective.objectiveType === 'QUANTITATIVE_THRESHOLD') || (objective.objectiveType === 'QUANTITATIVE_DIMENSIONAL_THRESHOLD')) {
            if (objective.endComparisonOperator == null) {
                return getIconWithTooltip(ThresholdObjectiveTypeIcon, {}, t('Threshold Objective'));
            }
            return getIconWithTooltip(RangeObjectiveTypeIcon, {}, t('Range Objective'));
        }
    }

    const recognizedObjectiveTypes = ['QUANTITATIVE', 'QUANTITATIVE_THRESHOLD', 'QUANTITATIVE_DIMENSIONAL', 'QUANTITATIVE_DIMENSIONAL_THRESHOLD'];
    if (!recognizedObjectiveTypes.includes(objective.objectiveType)) {
        return null;
    }
    return (
        <FieldIcon label={showFieldName ? t('Objective Type') : null} icon={returnIcon()} className={'objective-type-field-icon'} />
    );
};

export default ObjectiveTypeIcon;